import {isDef} from "../objtools";

export const identifySwaggerVersion = (swagger_developed) => {
  if (isDef(swagger_developed, 'swagger') && swagger_developed.swagger === '2.0')
    return 2
  else if(isDef(swagger_developed,'openapi'))
    return 3
}
